import styled from "styled-components";
import {
  color,
  elevation,
  spacing,
  palette,
  fontWeight,
} from "@conserveit/blocks";

export const TileContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-basis: 800px;
  background: ${color.pureWhite};
  box-shadow: ${elevation.content};
`;

export const Tile = styled.div`
  flex-basis: 50%;
  padding: ${spacing.default};
  border-bottom: 1px solid ${color.theme.divider.solid};
  background: ${color.pureWhite};

  &:nth-child(2n - 1) {
    border-right: 1px solid ${color.theme.divider.solid};
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const Label = styled.h4`
  margin: 0 0 ${spacing.extraTight};
  font-size: 12px;
  line-height: 12px;
  font-weight: ${fontWeight.bold};
  color: ${color.theme.typography.ink};
  text-transform: uppercase;
`;

export const SubLabel = styled.p`
  margin: 0 0 ${spacing.default};
  font-size: 12px;
  line-height: 12px;
  color: ${color.theme.typography.ink};
  letter-spacing: -0.15px;
`;

export const MetricContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 0 0 ${spacing.loose};
`;

export const Metric = styled.span`
  display: inline-block;
  margin: 0 ${spacing.tight} 0 0;
  font-size: 42px;
  line-height: 42px;
  font-weight: ${fontWeight.bold};
`;

export const Description = styled.p`
  margin: 0;
  font-size: 12px;
  line-height: 16px;
  color: ${palette.neutral7};
`;
